// t603 · B-2443 · LO PRIMERO QUE CARGA main.jsx (antes que cualquier otro módulo de la app): si la página es la de una clínica con la
// edición local por el puente (https://biango.app/l/<instalación>/...), lo guardado en el navegador queda aparte por instalación y
// las peticiones a /api van por su puente ANTES de que ningún módulo lea nada. En cualquier otra dirección, no hace nada.
// El porqué y lo que hace: utils/puenteLocal.js.
import { instalar, puente } from './puenteLocal'

instalar()

export { puente }
